import {Fragment, ReactNode} from 'react'
import {Form} from 'react-bootstrap'
import Feedback from './Feedback'
import {FormikProps} from 'formik'

interface Props {
  required?: boolean
  disabled?: boolean
  formik: FormikProps<any>
  label?: string
  name: string
  option: any[]
  keyValue?: string
  keyLabel?: string
  isCompany?: boolean
  isValueOnly?: boolean
  isSearch?: boolean
  isDefault?: boolean
}

const FormSelectField = ({
  required,
  disabled,
  formik,
  label,
  name,
  option,
  keyValue = 'value',
  keyLabel = 'name',
  isCompany,
  isValueOnly,
  isSearch,
  isDefault,
}: Props) => {
  return (
    <Form.Group className='mb-3'>
      <Form.Label>
        {label} {required && <span className='text-danger'>*</span>}
      </Form.Label>
      <Form.Select
        onChange={(e) => formik.setFieldValue(name, e.target.value)}
        disabled={disabled || formik.isSubmitting}
        isInvalid={formik.touched[name] && !!formik.errors[name]}
        value={formik.values[name]}
        // defaultValue={undefined || ''}
      >
        {!isValueOnly && isSearch ? (
          <option value={undefined || ''}>All</option>
        ) : (
          !isValueOnly && <option value={undefined || ''}>Select</option>
        )}

        {option.map((item) => {
          return (
            <Fragment key={isCompany ? item.company[keyValue] : item[keyValue]}>
              {isCompany ? (
                <option value={item.company[keyValue]}>{item.company[keyLabel]}</option>
              ) : (
                <option value={item[keyValue]}>{item[keyLabel]}</option>
              )}
            </Fragment>
          )
        })}
      </Form.Select>
      {formik.touched[name] && formik.errors[name] && (
        <Feedback>
          <>{formik.errors[name]}</>
        </Feedback>
      )}
    </Form.Group>
  )
}

FormSelectField.defaultProps = {
  type: 'select',
}

export default FormSelectField
